<template>
	<div class="container">
		<div
			:class="[
				isSmall ? 'max-w-screen-md' : '',
				isCenter ? 'px-8 mx-auto' : '',
			]"
		>
			<slot />
		</div>
	</div>
</template>

<script lang="ts" setup>
defineProps<{
	isSmall?: boolean;
	isCenter?: boolean;
}>();
</script>
